import React from 'react';
import SearchResults from '../../components/search/components/SearchResults';
import HeaderTags from '../../common/headerTags/HeaderTags';

const headerTags =
{
    title: 'Pesquisa - Artistas, músicas ou notícias', // ' | Antena 1' will be append by the HeaderTags component
    meta:
    {
        description: 'Faça a sua pesquisa no buscador da Antena 1 e facilite sua procura por novidades sobre o seu artista favorito.',
        keywords: 'buscar, pesquisar, procura',
        'og:title': 'Pesquisa - Artistas, músicas ou notícias',
        'og:description': 'Faça a sua pesquisa no buscador da Antena 1 e facilite sua procura por novidades sobre o seu artista favorito.',
        robots: 'noindex, follow', // https://www.agenciamestre.com/web-analytics/site-search-tutorial-seo-busca-interna/
    },
};

const Busca = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <SearchResults />
    </div>);

export default Busca;
